import { withInstall } from '@bigin/utils'
import Popper from './src/popper.vue'

import BPopperArrow from './src/arrow.vue'
import BPopperTrigger from './src/trigger.vue'
import BPopperContent from './src/content.vue'

export { BPopperArrow, BPopperTrigger, BPopperContent }

export const BPopper = withInstall(Popper)
export default BPopper

export * from './src/popper'
export * from './src/trigger'
export * from './src/content'
export * from './src/arrow'

export type { Placement, Options } from '@bigin/popperjs-es'
export type BPopperArrowInstance = InstanceType<typeof BPopperArrow>
export type BPopperArrowTrigger = InstanceType<typeof BPopperTrigger>
export type BPopperArrowContent = InstanceType<typeof BPopperContent>
